import React from "react";
import {
  DataGrid,
  GridFooterContainer,
  GridPagination,
} from "@mui/x-data-grid";
import { Pagination as MuiPagination, Typography } from "@mui/material";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import "./table.css";

const CustomGrid = ({
  columns,
  data = [],
  loading = false,
  onChangeRecords,
  perPageCount,
  currentPage,
  totalPages,
  isServerPagination,
  getRowId,
  isServerSorting,
  onSortModelChange,
  onRowClick,
  searchBar,
  checkboxSelection,
  handleRowSelectable,
  onRowSelectionModelChange,
  rowHeight,
  selectionModel,
  disableMultipleRowSelection = false,
  onPageSizeChange,
  disableSorting = false,
}) => {
  const customOverlay = () => {
    return <div className="table-empty-container">No records found</div>;
  };

  const handlePaginationModelChange = (params) => {
    if (onChangeRecords) {
      onChangeRecords(params.page);
    }
    if (onPageSizeChange && params.pageSize !== perPageCount) {
      onPageSizeChange(params.pageSize);
    }
  };

  const CustomFooter = () => {
    const Pagination = ({ page, onPageChange, className }) => {
      const totalPageCount = Math.ceil(totalPages / perPageCount);
      return (
        <MuiPagination
          color="primary"
          className={className}
          count={totalPageCount}
          page={page + 1}
          onChange={(event, newPage) => {
            onPageChange(event, newPage - 1);
          }}
        />
      );
    };
    return (
      <GridFooterContainer>
        <GridPagination ActionsComponent={Pagination} />
      </GridFooterContainer>
    );
  };

  const UnsortedIcon = ({ className }) => {
    return <SwapVertIcon className={className} />;
  };

  return (
    <>
      <DataGrid
        rows={data ? data : []}
        checkboxSelection={checkboxSelection}
        columns={columns}
        disableColumnSorting={disableSorting}
        getRowId={getRowId}
        rowCount={Number(totalPages)}
        paginationModel={{ page: currentPage, pageSize: perPageCount }}
        onPaginationModelChange={handlePaginationModelChange}
        paginationMode={isServerPagination ? "server" : "client"}
        sortingMode={isServerSorting ? "server" : "client"}
        pageSizeOptions={[10, 25, 50, 100]}
        disableColumnMenu
        loading={loading}
        columnHeaderHeight={44}
        onSortModelChange={onSortModelChange}
        showCellVerticalBorder={true}
        rowHeight={rowHeight ? rowHeight : 50}
        localeText={{
          MuiTablePagination: {
            labelRowsPerPage: "Rows per page",
          },
        }}
        slots={{
          noRowsOverlay: customOverlay,
          toolbar: searchBar,
          footer: CustomFooter,
          columnUnsortedIcon: UnsortedIcon,
        }}
        onRowClick={onRowClick}
        isRowSelectable={handleRowSelectable}
        onRowSelectionModelChange={onRowSelectionModelChange}
        rowSelectionModel={selectionModel}
        disableMultipleRowSelection={disableMultipleRowSelection}
      />
    </>
  );
};

export default CustomGrid;
